export default __webpack_public_path__ + "static/media/mh-bedroom-3rd-4th-family-bathroom-01.937977c7.jpg";